<template>
  <div>
    <div
      class="mt-2 mb-3"
      :style="`width: ${width}; height: ${height}; margin: auto`"
    >
      <doughnut-chart-initial
        :data="donutChart.data"
        :options="donutChart.options"
      />
    </div>
    <div class="d-flex align-items-center justify-content-center flex-wrap">
      <div
        v-for="(label, index) in labels"
        :key="index"
        class="d-flex align-items-center mx-50"
      >
        <div
          :style="[
            ,
            {
              'border-radius': '3px',
              width: '18px',
              height: '4px',
              backgroundColor: colors[index],
            },
          ]"
          class="mr-50"
        ></div>
        <div class="small">{{ label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import DoughnutChartInitial from "./DoughnutChartInitial.vue";
export default {
  components: {
    DoughnutChartInitial,
  },
  props: {
    colors: {
      type: Array,
      default: () => [],
    },
    labels: {
      type: Array,
      default: () => [],
    },
    width: {
      type: String,
      default: "140px",
    },
    height: {
      type: String,
      default: "140px",
    },
    chartData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    donutChart() {
      return {
        options: {
          plugins: {
            datalabels: {
              display: true,
              backgroundColor: "#ccc",
              borderRadius: 3,
              font: {
                color: "red",
                weight: "bold",
              },
            },
            doughnutlabel: {
              labels: [
                {
                  text: "550",
                  font: {
                    size: 20,
                    weight: "bold",
                  },
                },
                {
                  text: "total",
                },
              ],
            },
          },
          responsive: true,
          aspectRatio: 1,
          maintainAspectRatio: true,
          responsiveAnimationDuration: 500,
          cutoutPercentage: 60,
          legend: {
            position: "bottom",
            reverse: true,
            labels: {
              padding: 25,
              fontSize: 12,
              fontColor: "#fff",
            },
          },

          tooltips: {
            callbacks: {
              label(tooltipItem, data) {
                const label = data.datasets[0].labels[tooltipItem.index] || "";
                const value = data.datasets[0].data[tooltipItem.index];
                const output = ` ${label} : ${value} %`;
                return output;
              },
            },
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 8,
          },
        },
        data: {
          datasets: [
            {
              labels: [...this.labels],
              data: [...this.chartData],
              backgroundColor: [...this.colors],
              borderWidth: 0,
              pointStyle: "rectRounded",
            },
          ],
        },
      };
    },
  },
};
</script>

<style></style>
